import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notice-icon" }
const _hoisted_2 = {
  key: 0,
  class: "badge bg-red notification-badge"
}
const _hoisted_3 = {
  key: 1,
  class: "badge bg-red notification-badge"
}
const _hoisted_4 = { class: "notice-panel" }
const _hoisted_5 = { class: "notice-title" }
const _hoisted_6 = { class: "notice-date" }

import Api from '@/services/api/ApiServiceFabrick';
import { onMounted, ref, reactive, watch } from 'vue';
import getNoticesResponse from "@/types/responses/getNotices";
import notice from '@/types/notice'


export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeMenu',
  props: {
    isHamburgerOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const noticeList: {
  data: notice[],
  unreadCount: number
} = reactive({
  data: [],
  unreadCount: 0,
})

onMounted(() => {
  getNoticeList()
})

const isOpen = ref()
const batchRemoved = ref(false)

watch(isOpen, () => {
  if (isOpen.value) {
    batchRemoved.value = true
    postWatched()
  }
})

const getNoticeList = () => {
  Api().getNotices().then((res: getNoticesResponse) => {
    noticeList.data = res.data
    noticeList.unreadCount = res.unread_count
  })
}

const postWatched = () => {
  if (noticeList.unreadCount == 0) return
  const watchedAt = noticeList.data[0].registered_at
  Api().upsertNoticeWatchedTime(watchedAt).then(() => {
    getNoticeList()
  })
}

const showAllNoticePage = () => {
  window.open(process.env.VUE_APP_SUPPORT_LINK, '_blank')
}

const showSpecifiedNoticePage = (url: string) => {
  window.open(url, '_blank')
}


return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (noticeList.data[0])
    ? (_openBlock(), _createBlock(_component_v_menu, {
        key: 0,
        modelValue: isOpen.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isOpen).value = $event))
      }, {
        activator: _withCtx(({props}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _mergeProps({ class: "material-symbols-outlined" }, props), " notifications ", 16),
            (noticeList.unreadCount > 0 && noticeList.unreadCount < 100 && !batchRemoved.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(noticeList.unreadCount), 1))
              : _createCommentVNode("", true),
            (noticeList.unreadCount >= 100 && !batchRemoved.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "99+"))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_list, { class: "notice-list" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                class: "all-notice",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showAllNoticePage()))
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" 全てのお知らせ ", -1)
                ]))]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.data, (data) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  class: "notice-item",
                  key: data.id,
                  onClick: ($event: any) => (showSpecifiedNoticePage(data.url))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(data.title), 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(data.date), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})